// extracted by mini-css-extract-plugin
module.exports = {"header":"CategoryView_header__3pzob","title":"CategoryView_title__2F2d9"};